import { type AnyAction, combineReducers } from 'redux';

import { setBrandKitId } from 'js/src/data/video/video-actions';

export function brand_kit_id(state: number | null = null, action: AnyAction) {
    if (setBrandKitId.match(action)) {
        return action.payload.brandKitId;
    }
    return state;
}

export const video = combineReducers({
    brand_kit_id,
});
